<template>
	<div class="d-flex justify-content-center align-items-start mx-auto" style="gap: 16px;max-width: 400px;">
		<!-- <label><strong>Clients</strong></label> -->
		<v-select class="w-100 bg-white" placeholder="Select a client" :options="clientList"
			v-model="$store.state.selectedClientList" :multiple="true"
			@input="(val) => $store.commit('set', ['selectedClientList', val])" />

		<CButton color="success" class="filter-btn apply" style="" @click="applyFilterHandler">Apply</CButton>
		<CButton color="danger" class="filter-btn clear" @click="clearFilterHandler">Reset</CButton>
	</div>
</template>

<script>
import { storeData } from "../store";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
		};
	},
	computed: {
		clientList() {
			return storeData.clientList.filter((el) => el.label !== "All");
		},
	},
	methods: {
		applyFilterHandler() {
			let client = this.$store.state.selectedClientList.map((el) => el.value);
			if (client.length === 0) {
				client = storeData.clientList.filter((el) => el.label !== "All").map((el) => el.value);
			}
			this.$emit("getSelectedClient", client);
		},
		clearFilterHandler() {
			this.$store.commit('set', ['selectedClientList', []])
		}
	},
	beforeMount() {
	},
};
</script>

<style></style>